import React, { useState, useEffect, useCallback } from 'react';
import ModelViewer from './ModelViewer';
import IotChartFor3d from '../Charts/IotChartFor3d';
import { graphFetch } from '../../api/fetchConfig';

const panelWidth = 420;
const panelMinWidth = 220;

const ModelViewerWithIotPanel = ({ tabId }) => {
  const [minimized, setMinimized] = useState(true);
  const [modelStatus, setModelStatus] = useState(null); // 'PROCESSING', 'COMPLETE', 'EMPTY'
  const [fileEntity, setFileEntity] = useState(null);

  const fetchModelStatus = useCallback(async () => {
    const query = `
      query Get3DModelStatus {
        get3DModelStatus {
          status
          fileEntity {
            filePath
            fileName
            fileExtension
          }
          iotDeviceList {
            deviceName
            fileId
          }
        }
      }
    `;
    
    try {
      const response = await graphFetch(query);
      const modelStatusResponse = response?.get3DModelStatus;
      
      // status만 사용하는 경우
      const status = modelStatusResponse?.status;
      setModelStatus(status || 'EMPTY');
      
      // 파일 경로 처리
      if (status === 'COMPLETE' && modelStatusResponse?.fileEntity) {
        setFileEntity(modelStatusResponse.fileEntity);
      } else {
        setFileEntity(null);
      }
      
      // IoT 디바이스 목록이 필요한 경우
      const iotDeviceList = modelStatusResponse?.iotDeviceList || [];
      console.log('IoT Devices:', iotDeviceList);
      
    } catch (error) {
      setModelStatus('EMPTY');
      setFileEntity(null);
    }
  }, []);

  // Initial fetch on mount
  useEffect(() => {
    fetchModelStatus();
  }, [fetchModelStatus]);

  // Polling based on status change
  useEffect(() => {
    if (modelStatus === 'PROCESSING') {
      const intervalId = setInterval(fetchModelStatus, 5000);
      return () => clearInterval(intervalId);
    }
  }, [modelStatus, fetchModelStatus]);

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <ModelViewer tabId={tabId} modelStatus={modelStatus} fileEntity={fileEntity} />

      {modelStatus === 'COMPLETE' && (
        <div
          style={{
            position: 'absolute',
            top: 24,
            right: 24,
            width: minimized ? panelMinWidth : panelWidth,
            minHeight: minimized ? 48 : 400,
            background: '#fff',
            border: '1px solid #eee',
            borderRadius: 8,
            boxShadow: '0 2px 12px #0001',
            zIndex: 20,
            transition: 'width 0.2s, min-height 0.2s',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {/* 상태바 */}
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            height: 48, padding: '0 16px', borderBottom: minimized ? 'none' : '1px solid #eee', background: '#f7f7f7',
          }}>
            <span style={{ fontWeight: 600, fontSize: 16 }}>IOT 전력량</span>
            <button
              style={{ border: 'none', background: 'none', fontSize: 20, cursor: 'pointer', color: '#888' }}
              onClick={() => setMinimized(m => !m)}
              title={minimized ? '확장' : '최소화'}
            >
              {minimized ? '+' : '-'}
            </button>
          </div>
          {/* 본문 */}
          <div style={{
            flex: 1,
            minHeight: minimized ? 0 : 352,
            height: minimized ? 0 : 352,
            padding: 8,
            overflow: 'auto',
            display: minimized ? 'none' : 'block'
          }}>
              <IotChartFor3d />
            </div>
        </div>
      )}
    </div>
  );
};

export default ModelViewerWithIotPanel; 